import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export default function ThemeProvider({ children, defaultTheme = 'ronin' }) {
  const [tokens, setTokens] = useState(null);
  const theme = process.env.REACT_APP_THEME || defaultTheme;

  useEffect(() => {
    let mounted = true;
    import(`../themes/${theme}.json`)
      .then((m) => {
        if (!mounted) return;
        const tokensObj = m.default || m;
        setTokens(tokensObj);

        // Inject CSS variables (normalize keys and log for debugging)
        const root = document.documentElement;
        Object.entries(tokensObj).forEach(([key, value]) => {
          // Normalize key to a valid CSS variable name
          const normalized = key.startsWith('--') ? key : `--${key.replace(/[^a-zA-Z0-9-_]/g, '')}`;
          root.style.setProperty(normalized, value);
        });

        // Set data attribute to help debugging and allow CSS selectors
        root.setAttribute('data-theme', theme);

        // Debug log so you can confirm in browser console
        // Note: remove or lower verbosity in production if desired
        // eslint-disable-next-line no-console
        console.log('ThemeProvider: injected theme', theme, tokensObj);

        // Dynamically load overrides CSS for this theme (non-blocking)
        import(`../themes/${theme}.overrides.css`).catch(() => {
          // eslint-disable-next-line no-console
          console.warn('No overrides CSS for theme', theme);
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('ThemeProvider: Failed to load theme:', err);
      });

    return () => {
      mounted = false;
    };
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, tokens }}>
      {children}
    </ThemeContext.Provider>
  );
}
